import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import animationData from "../subscription-needed-lottie/Subscription_Needed_Lottie.json";
import "./Subscription_Needed_Lottie_Modal.css";
const Subscription_Needed_Lottie_Modal = ({
  showSubscription,
  handleSubscriptionClose,
}) => {
  useEffect(() => {
    if (showSubscription) {
      const timer = setTimeout(() => {
        handleSubscriptionClose();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showSubscription, handleSubscriptionClose]);
  return (
    <Modal
      show={showSubscription}
      onHide={handleSubscriptionClose}
      centered
      className="add-money-success-modal"
    >
      <Modal.Body className="p-0">
        <div className="modal-card-container">
          <div className="success-circle-icon">
            <Lottie
              animationData={animationData}
              loop={true}
              style={{ width: "100px", height: "100px", margin: "0 auto" }}
            />
          </div>
          <div className="content">
            <p className="text">Subscription Needed</p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Subscription_Needed_Lottie_Modal;
